const overtimeTypes = [
  { name: '轉補休', value: 'overtime_leave', type: 'all' },
  { name: '轉補薪', value: 'overtime_pay', type: 'all' },
  { name: '值夜班', value: 'overtime_shift', type: 'nurse' },
];

export default overtimeTypes
